/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'

export const invitationPeekDataSchema = z.object({
	email: z.string(),
	organisationName: z.string(),
	hasAuthenticated: z.boolean(),
	organisationWorkosId: z.string(),
})

export type InvitationPeekDataSchema = z.infer<typeof invitationPeekDataSchema>
